module.exports = __webpack_public_path__ + "b3ad4dd9478a684766f84d149c6ccb6f.gif";